export default "__VITE_ASSET__A$85R1At__"